import bootbox from 'bootbox';

$(document).ready(function (e) {
    let $reports_to = $('#reports-to'),
        $master_checkbox = $('input[name="master"]'),
        $table_permissions = $('.table-permissions '),
        $role_permissions = $('.role-permissions');
    $('#master-group').on('change', function (e) {
        if ($(this).is(':checked')) {
            $reports_to.addClass('d-none');
            $master_checkbox.val(1);
            $table_permissions.addClass('d-none');
            $role_permissions.addClass('d-none');
        } else {
            $reports_to.removeClass('d-none');
            $master_checkbox.val(0);
            $table_permissions.removeClass('d-none');
            $role_permissions.removeClass('d-none');
        }
    });

    $('#delete-role').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-role-id');
        console.log(id);
        bootbox.confirm({
            message: "Are you sure you want to delete this role?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    window.location = `/settings/groups/delete/${id}`;
                }
            }
        });
    });

    $('.change-visibility').on('change', function (e) {
        let table_id = $(this).attr('data-table-id'),
            visibility = $(this).val();

        $.ajax({
            type: 'POST',
            url: '/settings/tables/visibility',
            data: {
                table_id: table_id,
                visibility: visibility,
            },
            success: function (res) {
                if (res) {
                    bootbox.alert(visibility === "0" ? translation.table_visibility_private : translation.table_visibility_everyone);
                }
            }
        });
    });

    $('.table-tracking-value').on('change', function (e) {
        let $select = $(this),
            table_id = $select.attr('data-table-id'),
            action = $select.attr('data-action'),
            value = $select.val();

        $.ajax({
            type: 'POST',
            url: '/settings/activity_log/tracking',
            data: {
                table_id: table_id,
                action: action,
                value: value,
            }
        });
    });

    $('.apply-to-all-tables').on('click', function (e) {
        e.preventDefault();

        let values = {};
        $('.bulk-tracking-value').each(function () {
            values[$(this).attr('data-action')] = $(this).val();
        });

        bootbox.confirm({
            message: translation.activity_log_apply_all_confirm || 'Apply these tracking levels to every table? Existing per-table settings will be overwritten.',
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (!result) {
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: '/settings/activity_log/tracking/bulk',
                    data: values,
                    success: function (res) {
                        if (res) {
                            window.location.reload();
                        }
                    }
                });
            }
        });
    });

    $('.retention-never').on('change', function (e) {
        let $checkbox = $(this),
            table_id = $checkbox.attr('data-table-id'),
            type = $checkbox.attr('data-type'),
            $row = $checkbox.closest('tr'),
            $months = $row.find('.retention-months[data-type="' + type + '"]'),
            never = $checkbox.is(':checked');

        $months.prop('disabled', never);
        saveRetention($row, table_id, type);
    });

    $('.retention-months').on('change', function (e) {
        let $input = $(this),
            table_id = $input.attr('data-table-id'),
            type = $input.attr('data-type'),
            $row = $input.closest('tr');

        saveRetention($row, table_id, type);
    });

    function saveRetention($row, table_id, type) {
        let $months = $row.find('.retention-months[data-type="' + type + '"]'),
            $never = $row.find('.retention-never[data-type="' + type + '"]'),
            payload = {
                table_id: table_id,
            };

        payload['never_delete_' + type] = $never.is(':checked') ? 1 : 0;
        payload[type + '_retention_months'] = $months.val();

        // Preserve the other retention type's current values on this row so we don't clobber them
        ['basic', 'detailed'].filter(function (t) {
            return t !== type;
        }).forEach(function (otherType) {
            let $otherMonths = $row.find('.retention-months[data-type="' + otherType + '"]'),
                $otherNever = $row.find('.retention-never[data-type="' + otherType + '"]');
            payload['never_delete_' + otherType] = $otherNever.is(':checked') ? 1 : 0;
            payload[otherType + '_retention_months'] = $otherMonths.val();
        });

        $.ajax({
            type: 'POST',
            url: '/settings/activity_log/retention',
            data: payload
        });
    }

    $('.permission').on('change', handlePermissionsChange);
    $('.role-permission').on('change', handleRolePermissionsChange);

    if ($('#role-permissions').length) {
        handleRolePermissionsChange();
    }

    if ($('#table-permissions').length) {
        handlePermissionsChange();
    }

    if ($('#field-permissions').length) {
        handleFieldPermissionsChange();
    }

    if ($('#button-permissions').length) {
        handleButtonPermissionChange();
    }

    if ($('#activity-log-permissions').length) {
        handleActivityLogPermissionsChange();
    }

    $('.change-field-permission').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).data('table-id');
        $('.field-permissions, .button-permissions').addClass('d-none');

        let $target = $('.field-permissions[data-table-id="' + table_id + '"]');

        if (!$target.hasClass('trans-loaded')) {
            $.ajax({
                type: 'GET',
                url: `/settings/table/${table_id}/translations`,
                success: function (data) {
                    Object.keys(data).forEach(function (key) {
                        $(`.tb-field[data-id="${key}"]`).text(data[key]);
                    });

                    $target.removeClass('d-none').addClass('trans-loaded');
                }
            })
        } else {
            $target.removeClass('d-none');
        }
    });

    $('.change-button-permission').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).data('table-id');
        $('.field-permissions, .button-permissions').addClass('d-none');
        $('.button-permissions[data-table-id="' + table_id + '"]').removeClass('d-none');
    });

    $('.select-permission').on('click', function (e) {
        e.preventDefault();
        let $selected = $(this),
            $dropdown = $selected.parents('.dropdown-menu'),
            $button = $($dropdown).siblings('.btn-default'),
            value = $(this).data('value');

        $($dropdown).find('.active').removeClass('active');
        $($selected).addClass('active');
        $($button).text(value);

        handleFieldPermissionsChange();
    });

    $('.select-btn-permission').on('change', function (e) {
        e.preventDefault();
        handleButtonPermissionChange();
    });

    $('.select-activity-log-permission').on('click', function (e) {
        e.preventDefault();
        let $selected = $(this),
            $dropdown = $selected.parents('.dropdown-menu'),
            $button = $($dropdown).siblings('.btn-default'),
            value = $(this).data('value');

        $($dropdown).find('.active').removeClass('active');
        $($selected).addClass('active');
        $($button).text(value);

        handleActivityLogPermissionsChange();
    });

    $(document).on('change', 'select.mail-access-users', function (e) {
        let users = $(this).val(),
            account_id = $(this).attr('data-account-id');

        console.log('Changed');

        $.ajax({
            type: 'POST',
            url: '/settings/mail/access',
            data: {
                users,
                account_id
            },
            success: function (res) {

            }
        });
    })

    $('#generate-api-token').on('click', function (e) {
        e.preventDefault();

        $.ajax({
            url: '/settings/users/api_token',
            type: 'POST',
            data: { user_id: $(this).data('user-id') },
            success: function (response) {
                $('#api_token').val(response.token);

                // Bootbox alert
                bootbox.alert({
                    title: "API Token Generated",
                    message: `
                        <p><strong>Important:</strong></p>
                        <p>
                            Your API token is shown below. 
                            Please copy it and store it securely. 
                            You will need it to make API requests.
                        </p>
                        <p>
                            <input type="text" class="form-control" 
                                   value="${response.token}" 
                                   readonly 
                                   onclick="this.select();">
                        </p>
                        <p><strong>This token will not be shown again.</strong></p>
                    `
                });
            },
            error: function (xhr) {
                alert('Failed to generate API token');
            }
        });
    });
});

function handleFieldPermissionsChange() {
    let $fields = $('.select-permission.active'),
        permissions = [];
    $fields.each(function (i, $permission) {
        let permission = {
            field_id: $($permission).data('field-id'),
            table_id: $($permission).data('table-id'),
            value: $($permission).data('permission'),
        };
        permissions.push(permission);
    });
    $('#field-permissions').val(JSON.stringify(permissions));
}

function handleButtonPermissionChange() {
    let $fields = $('.select-btn-permission'),
        permissions = [];
    $fields.each(function (i, $permission) {
        let permission = {
            button_id: $($permission).data('button-id'),
            table_id: $($permission).data('table-id'),
            value: $($permission).is(':checked') ? 1 : 0,
        };
        permissions.push(permission);
    });
    $('#button-permissions').val(JSON.stringify(permissions));
}

function handleActivityLogPermissionsChange() {
    let $fields = $('.select-activity-log-permission.active'),
        permissions = [];
    $fields.each(function (i, $permission) {
        let permission = {
            table_id: $($permission).data('table-id'),
            value: $($permission).data('permission'),
        };
        permissions.push(permission);
    });
    $('#activity-log-permissions').val(JSON.stringify(permissions));
}

function handlePermissionsChange() {
    let $rows = $('.table-permissions').find('tbody > .permission-data'),
        permissions = [];

    $.each($rows, function (index, $row) {
        let $permissions = $($row).find('td > input'),
            table_id = $($row).attr('data-table-id'),
            permission = {};

        $.each($permissions, function (index, $permission) {
            permission[$($permission).attr('data-name')] = !!$($permission).is(':checked');
        });

        permissions.push({
            table_id: table_id,
            permissions: permission
        });
    });

    $('#table-permissions').val(JSON.stringify(permissions));
}

function handleRolePermissionsChange() {
    let $rows = $('.role-permissions').find('.role-permission'),
        permissions = {};

    $.each($rows, function (index, $row) {
        permissions[$($row).attr('data-name')] = !!$($row).is(':checked');
    });

    $('#role-permissions').val(JSON.stringify(permissions));
}